export const formatCodecLabel = (value?: string | null, fallback = '--') => {
  const raw = String(value || '').trim();
  if (!raw) return fallback;
  const key = raw.toLowerCase();
  if (key === 'h264' || key === 'libx264' || key === 'avc') return 'H264';
  if (key === 'aac' || key === 'mp4a' || key === 'mpeg-4 audio') return 'AAC';
  if (key === 'opus' || key === 'libopus') return 'Opus';
  if (key === 'h265' || key === 'hevc' || key === 'libx265') return 'H265';
  if (key === 'vp9') return 'VP9';
  if (key === 'av1') return 'AV1';
  return raw.toUpperCase() === raw ? raw : raw.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatCodecPair = (video?: string | null, audio?: string | null, fallback = '--') => {
  const parts = [video, audio].filter(Boolean).map((item) => formatCodecLabel(item, ''));
  return parts.length ? parts.join(' / ') : fallback;
};
